import { IconAmount, IconConverter } from 'icon-sdk-js';

export const round = (value, decimals) => {
  return Number(
    // @ts-ignore
    Math.round(value + 'e' + decimals) + 'e-' + decimals
  );
};

export const convertHexToDecimal = (hex) => {
  return parseInt(hex, 16);
};

export const convertLoopToIcx = (value) => {
  const bigNumber = IconConverter.toBigNumber(
    IconAmount.of(value, IconAmount.Unit.LOOP).convertUnit(IconAmount.Unit.ICX)
  );
  return Number(bigNumber);
};

export const convertIcxToLoop = (value) => {
  return IconAmount.of(value, IconAmount.Unit.ICX).toLoop();
};

export const convertLoopToToken = (value) => {
  return IconConverter.toBigNumber();
};

export const formatNumber = (num) => {
  return num.toLocaleString('en');
};
